module.exports = __webpack_public_path__ + "img/ddyz_sel.8893354a.svg";